/*
function getCookie (cname) {
  let name = cname + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function setCookie (cname, cvalue, exdays, isGlobal) {
  let d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  let expires = 'expires=' + d.toUTCString()
  if (isGlobal)
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
  else
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/; SameSite=none; Secure'

}

function deleteCookie (cname, isGlobal) {
  if (isGlobal)
    document.cookie = cname + '=; expires=Thu, 18 Dec 1999 12:00:00 UTC'
  else
    document.cookie = cname + '=; expires=Thu, 18 Dec 1999 12:00:00 UTC;path=/; SameSite=none; Secure'
}
*/

function getCookieX (cname) {
  let result = window.localStorage.getItem(cname)
  // alert('get cookie: ' + result)
  if (cname) {
    return result
  }
  return ''
}

// eslint-disable-next-line no-unused-vars
function setCookieX (cname, cvalue, exdays) {
  window.localStorage.setItem(cname, cvalue)
  // alert('set cookie: ' + cname + ' , value: ' + cvalue)
}

function deleteCookieX (cname) {
  window.localStorage.removeItem(cname)
  // alert('delete cookie: ' + cname)
}


export default {
  getCookie: getCookieX,
  setCookie: setCookieX,
  deleteCookie: deleteCookieX,
}
